import { ANALYTICS_KEY } from '../../constants'
import { Div } from '../../ui/Div'
import { LinkButton } from '../../ui/Link/LinkButton'
import { Text } from '../../ui/Text'

export type BannerProps = {
  label?: string
  buttonLabel?: string
  buttonUrl?: string
}

// Allows content editors to bold part of the banner text with **double asterisks**
// without needing a rich text field in Contentful.
const BOLD_PATTERN = /\*\*(.+?)\*\*/g

function renderLabel(label: string) {
  return label
    .split(BOLD_PATTERN)
    .map((part, index) =>
      index % 2 === 1 ? (
        <Text key={index} color="background" css={{ fontWeight: 700 }}>
          {part}
        </Text>
      ) : (
        part
      ),
    )
}

export function Banner({ label, buttonLabel, buttonUrl }: BannerProps) {
  if (!label) return null

  return (
    <Div
      as="nav"
      width="100%"
      alignItems="center"
      justifyContent="center"
      background="primary"
      spacingVertical={0.5}
      spacingHorizontal={3}
      zIndex={20}
      flexWrap="wrap"
      gap={2}
    >
      <Text
        variant="body"
        color="background"
        css={{ textAlign: 'center' }}
        data-qa={ANALYTICS_KEY.Banner}
      >
        {renderLabel(label)}
      </Text>
      {buttonLabel && buttonUrl && (
        <LinkButton
          href={buttonUrl}
          variant="secondary"
          compact
          data-qa={ANALYTICS_KEY.BannerButton}
        >
          {buttonLabel}
        </LinkButton>
      )}
    </Div>
  )
}
